import * as React from 'react';
import {Breadcrumb, Grid, Input, Dropdown, Responsive} from 'semantic-ui-react';
import i18n from '../../../../locale/i18n';
import {NavLink, RouteComponentProps, withRouter} from 'react-router-dom';
import {
    AdditionalDataServiceComponentProps,
    ColumnSelectableComponentProps,
    ColumnSortableComponentProps,
    FilterObjectComponentProps,
    InfinityScrollComponentProps,
    ViewSettingsComponentProps, withAdditionalDataServices,
    withColumnSelection,
    withColumnSort,
    withFilterObject,
    withInfinityScrollHandlers,
    withPrintAndExport,
    withViewSettings
} from '../../components/DataTable/dataService';
import {DataTable} from '../../components/DataTable/DataTable';
import LoadingSpinner from '../../containers/LoadingContainer/LoadingSpinner';
import {ColumnDefinition} from '../../components/DataTable/common';
import {formatCurrency} from '../../utils/numbers';
import ContentContainer from '../../containers/ContentContainer/ContentContainer';
import {ColumnSelectionButton} from '../../components/DataTable/ColumnSelection';
import LoadingContainer from '../../containers/LoadingContainer/LoadingContainer';
import AuthService from "../../services/AuthService"
import {default as DatePicker /*, registerLocale, setDefaultLocale */} from "react-datepicker/es";
//import Moment from 'react-moment';
//import moment from 'moment';
import AuctionServiceInstance from "../../services/AuctionService";
import './DateStatistics.css';
import {DataList} from "../../components/DataTable/DataList";
import {SortSelectionButton} from "../../components/DataTable/SortModal";
import {ViewLoadingSpinner} from "../../components/ViewLoadingSpinner";
import {TranslationFunction} from "i18next";
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";

const t = i18n.t.bind(i18n);
const nonBreakableWhiteSpace = "\xa0";


const COLUMNS: ColumnDefinition[] = [
    {
        fieldName: 'data.sorteNr2',
        labelTranslationKey: 'Auctions.Article',
        required: true,
    }, {
        fieldName: 'data.laenge',
        labelTranslationKey: 'Auctions.Length',
        required: true
    },
    {
        fieldName: 'data.beschreibung',
        labelTranslationKey: 'Auctions.Description',
        required: false,
        cellRender: (v, row) => <NavLink to={ {
            pathname: `/auctions/${row.data.sorteNr2}/${row.data.laenge}`
        }
        }>{nonBreakableWhiteSpace + v} </NavLink>,
    },
    {
        fieldName: 'data.gesamtAnzahl',
        labelTranslationKey: 'Auctions.Count',
        required: false
    },
    {
        fieldName: 'data.preisNiedrig',
        labelTranslationKey: 'Auctions.PriceLow',
        required: false,
        cellRender: v => formatCurrency(v),
        printExportRender: v => formatCurrency(v)
    },
    {
        fieldName: 'data.preisDurchschnitt',
        labelTranslationKey: 'Auctions.PriceAverage',
        required: false,
        cellRender: v => formatCurrency(v),
        printExportRender: v => formatCurrency(v)
    },
    {
        fieldName: 'data.preisHoechst',
        labelTranslationKey: 'Auctions.PriceMax',
        required: false,
        cellRender: v => formatCurrency(v),
        printExportRender: v => formatCurrency(v)
    }

];

const renderMobileListItem = (row: any, t: TranslationFunction) => {
    return <>
        <div>
            <NavLink style={{fontWeight: 'bold'}} to={ `/auctions/${row.data.sorteNr2}/${row.data.laenge}`}>{(!row.data.beschreibung || row.data.beschreibung.trim().length === 0) ? '' + row.data.sorteNr2 : row.data.beschreibung}</NavLink>
            <div>{t('Auctions.Article')} {row.data.sorteNr2} ⸱ {t('Auctions.Length')} {row.data.laenge}</div>
        </div>
        <div style={{textAlign: 'right', flexGrow: 1}}>
            <div style={{display: 'flex'}}>
                <div style={{textAlign: 'right', flexGrow: 1, marginRight: '1em'}}>{t('Auctions.Count_Short')} {row.data.gesamtAnzahl}&nbsp;</div>
                <div style={{textAlign: 'right'}}> &#8960; {formatCurrency(row.data.preisDurchschnitt)} €</div>
            </div>
            <div style={{display: 'flex'}}>
                <div style={{textAlign: 'right', flexGrow: 1, marginRight: '1em'}}>▼ {formatCurrency(row.data.preisNiedrig)} €</div>
                <div style={{textAlign: 'right'}}>▲ {formatCurrency(row.data.preisHoechst)} €</div>
            </div>
        </div>
    </>;
};


const getScrollParent = () => ContentContainer.instance.componentRef.current;

const DEFAULT_COLUMNS = COLUMNS.map(c => c.fieldName);

const ArticleStatistics = (props: RouteComponentProps<any> & InfinityScrollComponentProps & ColumnSelectableComponentProps & ColumnSortableComponentProps & FilterObjectComponentProps & AdditionalDataServiceComponentProps & ViewSettingsComponentProps) => {

    if (!props.filterObject.selectedDate) {

        if (props.additionalData.dates && props.additionalData.dates.length > 0)
            props.handleFilterChange("selectedDate", new Date(props.additionalData.dates[props.additionalData.dates.length - 1]));

        return <></>
    }

    let types = [];


    let privileges: Array<any> = AuthService.principal.privileges || [];
    let userRole = AuthService.principal ? AuthService.principal.userRole : '';

    if (privileges.indexOf("1") !== -1 || userRole === 'A') {
        types.push({key: "S", text: t("Auctions.Cut"), value: "S"});
    }

    if (privileges.indexOf("11") !== -1 || userRole === 'A') {
        types.push({key: "T", text: t("Auctions.Pot"), value: "T"});
    }

    if(props.loadingInitial) {
        return <LoadingContainer showLogo={false}/>;
    }
    return (
        <>
            <AnalyticsTracking page="auctions" />
            <div className={"sticky-header"}>
                <div className={"ui container"}>

                    <h3><Breadcrumb icon="right angle" sections={[
                        {
                            key: '1',
                            as: NavLink,
                            to:  "/auctions/",
                            content: `${t ("Route.Auctions")}`,
                        }
                    ]} /></h3>

                    <p>{t("Common.Found$dDatasets", {count: props.totalItems})}</p> <br/>

                    <Grid columns={5} className={"HeadingGrid"}  stackable={true} style={{marginBottom:'1em'}}>
                        <Grid.Column width={4}>
                            <Dropdown fluid options={types} defaultValue={props.filterObject.type || (types.length > 0 ? types[0].key : undefined)} selection
                                      onChange={(_, data)=> {props.handleFilterChange("type", data.value)}}/>
                        </Grid.Column>
                        <Grid.Column  width={4}>
                            <div className={"ui input fluid"}>
                            <DatePicker
                                className={"fluid"}
                                selected={new Date(props.filterObject.selectedDate)}
                                onChange={(date: string)=> props.handleFilterChange("selectedDate",date)}
                                dateFormat={t("Common.DateFormatPicker")}
                                includeDates={props.additionalData.dates}
                            /></div>
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <Input fluid icon={'search'} placeholder={t("Forms.Placeholder.Search")}
                                   value={props.filterObject.filter} onChange={(_, data)=> {props.handleFilterChange("filter", data.value)}}/>
                        </Grid.Column>
                        <Responsive maxWidth={960} as={Grid.Column} width={3}>
                                <SortSelectionButton
                                  fluid={true}
                                  availableColumns={COLUMNS}
                                  currentSortColumn={props.sortColumn}
                                  currentDirection={props.sortDirection}
                                  onSave={props.handleSortUpdate}/>
                        </Responsive>
                        <Responsive minWidth={961} as={Grid.Column} width={3}>
                                <ColumnSelectionButton
                                    fluid
                                    availableColumns={COLUMNS}
                                    selectedColumns={props.selectedColumns}
                                    onSave={props.updateSelectedColumns}/>
                        </Responsive>
                        <ViewLoadingSpinner active={props.loading} />
                    </Grid>
                </div>
            </div>


            <div className={"ui container responsivewrapper"}>
                <Responsive minWidth={961}>
                    <DataTable
                      columns={COLUMNS}
                      data={props.data}
                      page={props.page}
                      totalPages={props.totalPages}
                      sortDirection={props.sortDirection}
                      sortColumn={props.sortColumn}
                      selectedColumns={props.selectedColumns}
                      getScrollParent={getScrollParent}
                      loadMore={props.loadMore}
                      handleSortChange={props.handleSortChange}
                      loading={props.loading}
                      filter={props.filterObject}
                    />
                </Responsive>
                <Responsive maxWidth={960}>
                    <DataList data={props.data}
                              page={props.page}
                              totalPages={props.totalPages}
                              getScrollParent={getScrollParent}
                              loadMore={props.loadMore}
                              columns={COLUMNS}
                              renderItem={renderMobileListItem}
                              />
                </Responsive>

                <div style={{opacity: props.loadingMore ? '1.0' : '0.0'}}>
                    <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
                    </div>
                </div>
                <div style={{height: '2em'}}/>
            </div>
        </>
    )
};

const dataService = {
    loadPage(page: number, sortColumn: string, sortOrder: 'ASC' | 'DESC', filter: { [p: string]: any }): Promise<any> {
        return AuctionServiceInstance.getAllData(filter, sortColumn, sortOrder, page, 250);
    }
};

const ArticlesWrapped = withRouter(withViewSettings(withFilterObject(withColumnSort(withColumnSelection(withPrintAndExport(withAdditionalDataServices(withInfinityScrollHandlers(ArticleStatistics))))))));

export default () => (
    <ArticlesWrapped
        viewName="articles"
        dataService={dataService}
        defaultSortDirection="ASC"
        defaultSortColumn="data.sorteNr2"
        defaultColumns={DEFAULT_COLUMNS}
        defaultFilter={{
            selectedDate: null,

        }}
        printColumns={COLUMNS}
        printPath={[`${t ("Route.Auctions")}`]}
        dataToLoad={{
            dates: {
                uri: "auction/dates"
            }
        }
        }
    />
);

